import React, {
    createContext,
    useContext,
    useState,
    useEffect,
} from 'react';

type State = {
    isMobile: boolean;
};

type Props = {
    children: React.ReactNode;
};

const WindowDimensionsContext = createContext<State>({} as State);

export const WindowDimensionsProvider: React.FC<Props> = ({ children }) => {
    const [isMobile, setIsMobile] = useState<boolean>(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 600);

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, [])

    return (
        <WindowDimensionsContext.Provider
            value={{
                isMobile,
            }}
        >
            {children}
        </WindowDimensionsContext.Provider>
    );
};

export const useWindowDimensions = (): State => {
    const context = useContext(WindowDimensionsContext);

    return context;
};